/**
 * @author zqx
 * @description 操作日志
 */
import { getOperateLog, getSysSituation } from "@/api/operateLog";

const state = () => ({});

const getters = {};
// 同步方法写在这里--对应commit
const mutations = {};
// 异步请求写在这里--对应dispatch
const actions = {
  // 获取考试列表
  getOperateLog({}, data) {
    return new Promise((resolve, reject) => {
      getOperateLog(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取系统概况接口
  getSysSituation({}, data) {
    return new Promise((resolve, reject) => {
      getSysSituation(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default { state, getters, mutations, actions };
